var exports = {
  "kL": "xa15a2ab7--0a3187--container",
  "lY": "xa15a2ab7--0a3187--popup",
  "rT": "xa15a2ab7--0a3187--social_row",
  "vk": "xa15a2ab7--0a3187--vk",
  "ok": "xa15a2ab7--0a3187--ok",
  "Qq": "xa15a2ab7--0a3187--text",
  "Jk": "xa15a2ab7--0a3187--copy_link",
};

module.exports = exports;
